<template>
  <a-drawer
    :maskClosable="false"
    width="65%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />

    <a-form-model
      :model="form"
      ref="form"
      :label-col="{ span: 3 }"
      :rules="rules"
      :wrapper-col="{ span: 10 }"
      class="padding-lr"
    >
      <a-tabs tab-position="top" v-model="tabIndex">
        <a-tab-pane :key="1" tab="基础信息">
          <a-row :gutter="12">
            <a-col :span="24">
              <a-form-model-item label="商品分类" prop="categoryId" class="margin-bottom-10">
                <a-select
                  show-search
                  :allowClear="true"
                  v-model="form.categoryId"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option v-for="d in cateList" :key="d.id">{{ d.categoryName }}</a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item label="商品名称" prop="prodName" class="margin-bottom-10">
                <a-input v-model="form.prodName" placeholder="请输入" />
              </a-form-model-item>
              <a-form-model-item label="是否推荐" prop="isRecommend">
                <a-radio-group v-model="form.isRecommend" button-style="solid">
                  <a-radio-button :value="true"> 是 </a-radio-button>
                  <a-radio-button :value="false"> 否 </a-radio-button>
                </a-radio-group>
              </a-form-model-item>
              <a-form-model-item label="商品简述" prop="brief">
                <a-input v-model="form.brief" type="textarea" placeholder="请输入" :maxLength="500" allow-clear />
              </a-form-model-item>
              <a-form-model-item label="商品主图" prop="pic">
                <file-upload
                  type="image"
                  :defaultList="form.pic"
                  @input="getImg($event, 'pic')"
                  :file="form.pic"
                  :count="1"
                  :autoCropHeight="210"
                  :autoCropWidth="164"
                ></file-upload>
              </a-form-model-item>
              <a-form-model-item label="商品图册" prop="fileImgs">
                <file-upload
                  type="image"
                  :defaultList="form.fileImgs"
                  @input="getImg($event, 'fileImgs')"
                  :file="form.fileImgs"
                  :count="6"
                  :autoCropHeight="350"
                  :autoCropWidth="350"
                ></file-upload>
              </a-form-model-item>
              <!-- <a-form-model-item label="添加视频" class="margin-bottom-10">
                <a-switch v-model="form.isVideo" checked-children="开启" un-checked-children="关闭" />
              </a-form-model-item> -->
              <div v-if="form.isVideo">
                <a-form-model-item label="视频类型4" class="margin-bottom-10" prop="video">
                  <a-radio-group v-model="form.videoType" button-style="solid" @change="changeVideo">
                    <a-radio-button :value="1"> 本地视频 </a-radio-button>
                    <a-radio-button :value="2"> 视频链接 </a-radio-button>
                  </a-radio-group>
                </a-form-model-item>
                <a-row>
                  <a-col :span="2"></a-col>
                  <a-col :span="12">
                    <!-- <a-upload
                      v-if="form.videoType === 1"
                      action=""
                      list-type="picture-card"
                      :file-list="fileList"
                      @preview="handlePreview"
                      @change="uploadImages"
                    >
                      <div v-if="fileList.length < 1">
                        <a-icon type="video-camera" />
                        <div class="ant-upload-text">上传</div>
                      </div>
                    </a-upload> -->
                    <file-upload
                      v-if="form.videoType === 1"
                      type="video"
                      :defaultList="form.video"
                      @input="getImg($event, 'video')"
                      :file="form.video"
                      :count="1"
                      :autoCropHeight="350"
                      :isUpload="false"
                      :autoCropWidth="750"
                    ></file-upload>
                    <div v-if="form.videoType === 2" style="height: 93px; padding-top: 20px">
                      <a-input placeholder="请输入视频链接" v-model="form.video"></a-input>
                    </div>
                  </a-col>
                </a-row>
              </div>
              <a-divider></a-divider>
              <a-row style="margin: 30px 0">
                <a-col :span="2"></a-col>
                <a-col :span="12" class="margin-tb-lg">
                  <a-button type="primary" size="large" @click="changeTab(1, 'next')">下一步</a-button>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane :key="2" tab="规格库存">
          <!-- <a-form-model-item class="margin-bottom-10" label="商品规格">
            <a-radio-group v-model="form.isSpec" button-style="solid" @change="changeSpec">
              <a-radio-button :value="0"> 单规格 </a-radio-button>
              <a-radio-button :value="1"> 多规格 </a-radio-button>
            </a-radio-group>
          </a-form-model-item> -->
          <div v-show="form.isSpec === 0">
            <a-form-model-item class="margin-bottom-10" label="价值" prop="oriPrice">
              <a-input v-model="form.oriPrice" placeholder="请输入" suffix="￥" />
            </a-form-model-item>
            <!-- <a-form-model-item label="商品类型" prop="prodType">
              <a-radio-group v-model="form.prodType" button-style="solid">
                <a-radio-button :value="0"> 积分 </a-radio-button>
                <a-radio-button :value="1"> 金豆 </a-radio-button>
              </a-radio-group>
            </a-form-model-item> -->
            <a-form-model-item class="margin-bottom-10" label="积分" prop="scorePrice">
              <a-input v-model="form.scorePrice" placeholder="请输入" oninput="value=value.replace(/[^\d]/g,'')" />
            </a-form-model-item>
            <a-form-model-item class="margin-bottom-10" label="金豆" prop="goldBeansPrice">
              <a-input v-model="form.goldBeansPrice" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请输入" />
            </a-form-model-item>
            <a-form-model-item class="margin-bottom-10" label="库存" prop="totalStocks">
              <a-input
                v-model="form.totalStocks"
                placeholder="请输入"
                oninput="this.value=this.value.replace(/\D/g,'').replace(/^0+/,'')"
              />
            </a-form-model-item>
            <a-form-model-item class="margin-bottom-10" label="排序" prop="sort">
              <a-input v-model="form.sort" placeholder="请输入" oninput="value=value.replace(/[^\d]/g,'')" />
            </a-form-model-item>
          </div>
          <div v-show="form.isSpec === 1">
            <a-form-model-item label="请选择规格">
              <a-select
                v-model="curSpec"
                show-search
                placeholder="请选择规格"
                style="width: 200px"
                @change="handleChangeSpec"
              >
                <a-select-option :value="item.id" v-for="(item, index) in form.specList" :key="index">
                  {{ item.label }}
                </a-select-option>
              </a-select>
              <a-button v-if="curSpec" type="primary" @click="isShowSpec = true">确定</a-button>
            </a-form-model-item>
            <!-- start展示选择的规格信息 -->
            <div v-if="isShowSpec && form.specList.length">
              <div class="box margin-bottom-sm" v-for="(item, index) in form.specList[0].specs" :key="index">
                <div class="margin-bottom-xs">
                  {{ item.label }}
                  <a-icon type="close-circle" class="cursorhand margin-left-sm" @click="delSpec(index)" />
                </div>
                <div class="flex align-center">
                  <div v-for="(item1, index1) in item.spec_value" :key="index" class="flex align-center">
                    <a-input v-model="item1.label" placeholder="请输入" size="small" style="width: 80%" />
                    <a-button
                      v-if="index1 + 1 === item.spec_value.length"
                      type="primary"
                      size="small"
                      @click="add(2, index, index1)"
                      class="margin-left-sm margin-right"
                    >
                      添加
                    </a-button>
                    <a-icon
                      type="close-circle"
                      class="cursorhand margin-left-sm"
                      @click="del(2, index, index1)"
                    ></a-icon>
                  </div>
                </div>
              </div>
            </div>
            <!-- end  展示选择的规格信息 -->
            <a-button class="margin-tb" type="primary">立即生成</a-button>
            <!-- start 根据所选的规格，生成skuList,展示表格 -->
            <a-table
              :loading="loading"
              size="small"
              rowKey="postId"
              :columns="skuColumns"
              :data-source="skuList"
              :pagination="false"
              :bordered="true"
            >
              <!-- <div slot="key_name" slot-scope="text, record">{{  }}</div> -->
              <div slot="price" slot-scope="text, record">
                <a-input placeholder="请输入"></a-input>
              </div>
              <div slot="market_price" slot-scope="text, record">
                <a-input placeholder="请输入"></a-input>
              </div>
              <div slot="stock" slot-scope="text, record">
                <a-input-number placeholder="请输入"></a-input-number>
              </div>
              <div slot="weight" slot-scope="text, record">
                <a-input placeholder="请输入"></a-input>
              </div>
            </a-table>
            <!-- end   根据所选的规格，生成skuList,展示表格 -->
          </div>
          <a-divider></a-divider>
          <a-row style="margin: 30px 0">
            <a-col :span="2"></a-col>
            <a-col :span="12" class="margin-tb-lg">
              <a-button @click="changeTab(2, 'back')" size="large" class="margin-right">上一步</a-button>
              <a-button @click="changeTab(2, 'next')" type="primary" size="large">下一步</a-button>
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane :key="3" tab="其他设置">
          <a-form-model-item label="商品详情" prop="content" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
            <editor v-model="form.content" />
          </a-form-model-item>
          <a-divider></a-divider>
          <a-row style="margin: 30px 0">
            <a-col :span="2"></a-col>
            <a-col :span="12" class="margin-tb-lg">
              <a-button @click="submitForm" type="primary" size="large">保存</a-button>
            </a-col>
          </a-row>
        </a-tab-pane>
      </a-tabs>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { getObj, addObj, putObj } from '@/api/pressure/goods'
import editor from '@/components/Editor/Editor.vue'
export default {
  name: 'CreateForm',
  props: {
    // statusOptions: {
    //   type: Array,
    //   required: false,
    // },
    cateList: {
      type: Array,
      required: true,
    },
  },
  components: { editor },
  data() {
    const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系电话'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    return {
      loading: true,
      submitLoading: false,
      tabIndex: 1,
      formTitle: '',
      form: {
        id: undefined,
        categoryId: undefined,
        content: undefined,
        fileImgs: [],
        oriPrice: undefined,
        pic: undefined,
        prodName: undefined,
        prodType: 0,
        remark: undefined,
        scorePrice: 0,
        sort: 99,
        totalStocks: undefined,
        video: undefined,
        isSpec: 0,
        goldBeansPrice: 0,
        isRecommend: true,
        videoType: 1, // 1本地视频 2视频链接
      },
      isShowSpec: false,
      // 生成的skuList表格数据
      skuColumns: [
        {
          title: '规格',
          dataIndex: 'key_name',
          align: 'center',
          scopedSlots: { customRender: 'key_name' },
        },
        {
          title: '价格',
          dataIndex: 'price',
          align: 'center',
          width: 140,
          scopedSlots: { customRender: 'price' },
        },
        {
          title: '市场价格',
          dataIndex: 'market_price',
          align: 'center',
          width: 140,
          scopedSlots: { customRender: 'market_price' },
        },
        {
          title: '库存',
          dataIndex: 'stock',
          align: 'center',
          width: 140,
          scopedSlots: { customRender: 'price' },
        },
        {
          title: '重量',
          dataIndex: 'weight',
          align: 'center',
          width: 140,
          scopedSlots: { customRender: 'weight' },
        },
      ],
      curSpec: undefined,
      skuList: [],
      replaceFields: {
        title: 'label',
        key: 'id',
        value: 'id',
        children: 'children',
      },
      statusOptions: [
        {
          label: '上架',
          value: 1,
        },
        {
          label: '下架',
          value: 0,
        },
      ],
      status: 1,
      // 上传图片
      open: false,
      previewVisible: false,
      showLoading: false,
      previewImage: '',
      fileList: [],
      rules: {
        goldBeansPrice: [{ required: true, message: '请输入商品金豆', trigger: 'blur' }],
        totalStocks: [{ required: true, message: '请输入总库存', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        cateId: [{ required: true, message: '请选择文章分类', trigger: 'blur' }],
        prodName: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        oriPrice: [{ required: true, message: '请输入商品价值', trigger: 'blur' }],
        fileImgs: [{ required: true, message: '请上传商品相册', trigger: 'blur' }],
        categoryId: [{ required: true, message: '请选择商品分类', trigger: 'blur' }],
        brief: [{ required: true, message: '请输入商品简介', trigger: 'blur' }],
        pic: [{ required: true, message: '请上传商品主图', trigger: 'blur' }],
        scorePrice: [{ required: true, message: '请输入商品积分', trigger: 'blur' }],
        content: [{ required: true, message: '请输入商品详情', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {},
  watch: {},
  methods: {
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() {},
      })
    },
    /** 上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info5555', info)
      this.form[fieldName] = info
      this.$refs.form.clearValidate(fieldName)
    },
    changeSpec(e) {
      const value = e.target.value
      this.form.isSpec = value
    },
    changeTab(index, type) {
      if (type === 'next') {
        console.log(index, 'indexindex')
        //  this.$refs.form.validate((valid, object) => {
        //   if (valid) {
        //     this.tabIndex = index + 1
        //   } else {
        //     return false
        //   }
        // })
        console.log(index, '顶顶顶顶')
        if (index == 1) {
          // this.$refs.form.validate(['categoryId', 'prodName'], (errors, values) => {
          //   console.log(values,'valuesvalues');
          //   if (!errors) {
          //     // 这些字段验证通过
          //     // console.log('验证通过的字段值:', values)
          //     this.tabIndex = index + 1
          //   } else {
          //     // 这些字段验证失败，会自动变红
          //     console.log('验证失败的字段:', errors)
          //   }
          // })
          let validated = 0
          let allValid = true
          const fieldsToValidate = ['categoryId', 'prodName', 'brief', 'pic', 'fileImgs'] // 需要验证的字段名
          // 逐个验证字段
          fieldsToValidate.forEach((field) => {
            this.$refs.form.validateField(field, (error) => {
              validated++
              if (error) {
                console.log(`${field} 验证失败`, error)
                allValid = false
              }
              // 当所有字段都验证完成后
              if (validated === fieldsToValidate.length) {
                if (allValid) {
                  console.log('所有必填字段已填写完成')
                  this.tabIndex = index + 1
                  // 执行后续操作
                } else {
                  console.log('部分必填字段未填写')
                }
              }
            })
          })
        } else if (index == 2) {
          let validatedCount = 0
          let allValid = true
          const fieldsToValidate2 = ['oriPrice', 'scorePrice', 'goldBeansPrice', 'totalStocks', 'sort'] // 需要验证的字段名
          // 逐个验证字段
          fieldsToValidate2.forEach((field) => {
            this.$refs.form.validateField(field, (error) => {
              console.log(field, 'field')
              validatedCount++
              if (error) {
                console.log(`${field} 验证失败`, error)
                allValid = false
              }
              // 当所有字段都验证完成后
              if (validatedCount === fieldsToValidate2.length) {
                if (allValid) {
                  console.log('所有必填字段已填写完成')
                  this.tabIndex = index + 1

                  // 执行后续操作
                } else {
                  console.log('部分必填字段未填写')
                }
              }
            })
          })
        }
      } else if (type === 'back') {
        this.tabIndex = index - 1
      }
    },
    changeVideo(e) {
      console.log('切换', e)
      const value = e.target.value
      this.isVideo = value
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(function () {
        this.$refs.input.focus()
      })
    },
    showInputs() {
      this.inputVisibles = true
      this.$nextTick(function () {
        this.$refs.inputs.focus()
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 选择省
      onChangeProvince(e) {
      console.log(e, 'dddd点点滴')
      if (e.code) {
        this.form.province = e.value
      } else {
        this.form.province = ''
        this.form.city = ''
        this.form.area = ''
      }
    },
    /** 切换单规格还是多规格 **/
    handleChangeSpec(e) {
      console.log('选中规格', e)
      this.curSpec = e
    },
    // 选择市
       onChangeCity(e) {
      if (e.code) {
        this.queryParam.city = e.value
      } else {
        this.queryParam.city = ''
        this.queryParam.area = ''
      }
    },
    // 选择区
      onChangeArea(e) {
      if (e.code) {
        this.queryParam.area = e.value
      } else {
        this.queryParam.area = ''
      }
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        categoryId: undefined,
        content: undefined,
        fileImgs: [],
        oriPrice: undefined,
        pic: undefined,
        prodName: undefined,
        prodType: 0,
        remark: undefined,
        scorePrice: 0,
        sort: 99,
        totalStocks: undefined,
        video: undefined,
        isSpec: 0,
        goldBeansPrice: 0,
        isRecommend: true,
        videoType: 1, // 1本地视频 2视频链接
      }
      this.tags = []
      this.tagslist = []
    },
    /** 新增按钮操作 */
    handleAdd(e) {
      this.tabIndex = 1
      this.reset()
      this.open = true
      if (e) {
        this.form.categoryId = e
      }
      this.formTitle = '添加商品'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.tabIndex = 1
      this.reset()
      const postId = row ? row.id : ids

      getObj(postId).then((response) => {
        console.log(response.data, 'response.data')
        response.data.isSpec = 0
        this.form = response.data
        this.open = true
        this.formTitle = '修改商品'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')
      if (this.form.goldBeansPrice == 0 && this.form.scorePrice == 0)
        return this.$message.error('积分或金豆至少有一个不为0')
       this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          }
        } else {
           const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
/deep/.ant-tabs-tab {
  border: none !important;
  padding-top: 0 !important;
}
.ant-tabs-bar {
  border: none !important;
  /* 取消元素的阴影效果 */
  box-shadow: none !important;
  height: 45px !important;
  padding-top: 5px !important;
}
</style>
